import * as React from 'react';

import { Alert, AlertNotFoundIcon } from '../../../../components/Alert';
import { CADASTRE_NOT_FOUND_ALERT } from '../../const';

export const CadastreNotFoundAlert: React.FC = () => {
  const { title, message, testId } = CADASTRE_NOT_FOUND_ALERT;

  return <Alert icon={<AlertNotFoundIcon />} title={title} message={message} testId={testId} />;
};
